import { XStack, YStack } from "tamagui";

import {
  type ChoiceValue,
  NumberBadge,
  OptionBody,
  OptionBodyHoverWrapper,
  OptionSeparator,
  OtherTextInput,
  PencilBadge,
  QuestionScrollArea,
} from "@/conversation/AskUserQuestionsPanel/OptionParts";
import SkipOrSubmit from "@/conversation/AskUserQuestionsPanel/SkipOrSubmit";

export default function SingleChoiceQuestion({
  options,
  value,
  onChange,
  onSubmit,
  onSkip,
  isLast,
  allowOther = true,
  allowSkip = true,
  dataTrackingId,
}: {
  options: string[];
  value: ChoiceValue;
  onChange: (value: ChoiceValue) => void;
  onSubmit: () => void;
  onSkip: () => void;
  isLast: boolean;
  /** Show the free-text "Enter answer here" row. Off for constrained flows (e.g. rx). */
  allowOther?: boolean;
  /** Show the Skip control. Off for required flows (e.g. rx). */
  allowSkip?: boolean;
  dataTrackingId?: string;
}) {
  const otherActive = value.otherText.trim().length > 0;
  return (
    <>
      <QuestionScrollArea>
        {options.map((option, index) => (
          <YStack key={option}>
            {index > 0 && <OptionSeparator />}
            <OptionBodyHoverWrapper>
              <OptionBody
                label={option}
                checked={value.selected.includes(option)}
                dataTrackingId={dataTrackingId}
                badge={
                  <NumberBadge
                    checked={value.selected.includes(option)}
                    index={index}
                  />
                }
                showArrow
                onPress={() => {
                  onChange({ selected: [option], otherText: "" });
                  onSubmit();
                }}
              />
            </OptionBodyHoverWrapper>
          </YStack>
        ))}
      </QuestionScrollArea>
      {(allowOther || allowSkip) && (
        <>
          <OptionSeparator />
          <XStack
            alignItems="center"
            gap="$200"
            paddingLeft="$150"
            paddingRight="$150"
            marginTop="$100"
            marginBottom="$150"
          >
            {allowOther && (
              <XStack flex={1} alignItems="center" gap="$100">
                <PencilBadge />
                <OtherTextInput
                  value={value.otherText}
                  onChangeText={(otherText) =>
                    onChange({ selected: [], otherText })
                  }
                  onSubmitEditing={onSubmit}
                />
              </XStack>
            )}
            <SkipOrSubmit
              showSkip={allowSkip && !otherActive}
              showSubmit={otherActive}
              isLast={isLast}
              onSkip={onSkip}
              onSubmit={onSubmit}
            />
          </XStack>
        </>
      )}
    </>
  );
}
